import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaHandsHelping, FaRegCalendarCheck } from 'react-icons/fa';
import NavBarLogo from '../logo/landingNavBarLogo';
import NavBarButton from './NavBarButton';
import LoginText from './LandingPageSigninButton';
import LoginRegister from '../../Login/login';

const LandingPageNavBar = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [hideBusinessAccount, setHideBusinessAccount] = useState(false);

  const toggleModal = (hideBusiness = false) => {
    setHideBusinessAccount(hideBusiness);
    setIsModalVisible(!isModalVisible);
  };

  const isLoggedIn = () => {
    return localStorage.getItem('google_token');
  };

  const handleMyBookingClick = (e) => {
    if (!isLoggedIn()) {
      e.preventDefault();
      toggleModal(true);
    }
  };

  return (
    <>
      <nav className="bg-transparent absolute w-full top-0 z-10">
        <div className="w-full px-4 py-2 flex justify-between items-center">
          <NavBarLogo />
          <div className="hidden md:flex items-center ml-auto space-x-6">
            {/* Hidden on small screens */}
            <Link
              to="/partnerwithus"
              className="text-white text-lg font-bold hover:bg-gray-500 hover:bg-opacity-50 hover:text-white px-4 py-2 rounded-lg flex items-center transition duration-300 ease-in-out transform hover:scale-105 shadow-md"
            >
              <FaHandsHelping className="mr-2 text-xl" />
              Partner With Us
            </Link>
            <NavBarButton
              icon={FaRegCalendarCheck}
              label="My Booking"
              link="/profile"
              onClick={handleMyBookingClick}
            />
          </div>
          <div className="flex items-center ml-6">
            <LoginText toggleModal={() => toggleModal(false)} />
          </div>
        </div>
      </nav>

      <LoginRegister isVisible={isModalVisible} onClose={toggleModal} hideBusinessAccount={hideBusinessAccount} />
    </>
  );
};

export default LandingPageNavBar;
